import { useEffect, useMemo } from 'react'
import { generatePath, useLocation, useNavigate } from 'react-router-dom'
import { backButton } from '@telegram-apps/sdk-react'
import routes from '../routes'

const useBackButton = (teamspaceId?: string, projectId?: string) => {
  const navigate = useNavigate()
  const { state } = useLocation()

  const backRoute = useMemo(() => {
    if (state?.from) {
      return state.from
    } else {
      return generatePath(routes.private.board, { teamspaceId, projectId })
    }
  }, [projectId, teamspaceId, state])

  useEffect(() => {
    if (backButton) {
      backButton.show()
      return backButton.onClick(() => {
        navigate(backRoute)
        backButton.hide()
      })
    }
  }, [backButton, state, projectId, teamspaceId])

  return { backRoute }
}

export default useBackButton
